import React from "react";
import { lang } from "../lang";

// Component for tab navigation
function TabNavigation({ activeTab, setActiveTab }) {
  return (
    <div className="tabs">
      <button
        className={`tab ${activeTab === "focused" ? "active" : ""}`}
        onClick={() => setActiveTab("focused")}
      >
        {lang.app.focusedTab}
      </button>
      <button
        className={`tab ${activeTab === "todo" ? "active" : ""}`}
        onClick={() => setActiveTab("todo")}
      >
        {lang.app.todoTab}
      </button>
      <button
        className={`tab ${activeTab === "flashcards" ? "active" : ""}`} // New tab
        onClick={() => setActiveTab("flashcards")}
      >
        {lang.app.flashCardsTab || "Flash Cards"}{" "}
        {/* Use lang file or fallback */}
      </button>
    </div>
  );
}

export default TabNavigation;
